<template>
	<el-aside class="aside-container">
		<div class="flexCenter" style="position: fixed; left: 0; top: 70px; width: 260px; background: #f9fafb; height: 70px">
			<div class="aside-title" @click="openNewChat" :class="{ 'aside-title-disabled': !uisLogin }">
				<i class="el-icon-circle-plus-outline"></i>
				开启新对话
			</div>
		</div>

		<div class="aside-main" style="margin-top: 48px">
			<!-- 置顶对话 -->
			<div v-if="asideList.pinned && asideList.pinned.length > 0" class="group-section">
				<div class="group-title">置顶</div>
				<div v-for="item in asideList.pinned" :key="item.id" :class="{ 'aside-item-active': activeId == item.id}" class="aside-item">
					<!-- //title超过了之后... -->
					<div class="chat-title"  @click.stop="openChat(item)" :title="item.title">
						{{ item.title }}
					</div>
					<el-dropdown class="aside-item-edit" placement="bottom-start" trigger="click">
						<span class="el-dropdown-link">
							<i class="el-icon-more"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item icon="el-icon-edit" @click.native="handleRename(item, 1)">
								<a>重命名</a>
							</el-dropdown-item>
							<el-dropdown-item icon="el-icon-bottom" @click.native="handleTop(item)">
								<a>取消置顶</a>
							</el-dropdown-item>
							<el-dropdown-item class="dropdown-item-delete" icon="el-icon-delete" @click.native="handleDelete(item, '1')">
								<a>删除</a>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

			<!-- 今天对话 -->
			<div v-if="asideList.today && asideList.today.length > 0" class="group-section">
				<div class="group-title">今天</div>
				<div v-for="item in asideList.today" :key="item.id" :class="{ 'aside-item-active': activeId == item.id}" class="aside-item">
					<div class="chat-title"  @click.stop="openChat(item)" :title="item.title">
						{{ item.title }}
					</div>
					<el-dropdown class="aside-item-edit" placement="bottom-start" trigger="click" >
						<span class="el-dropdown-link">
							<i class="el-icon-more"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item icon="el-icon-edit" @click.native="handleRename(item, 2)">
								<a>重命名</a>
							</el-dropdown-item>
							<el-dropdown-item icon="el-icon-top" @click.native="handleTop(item)">
								<a>置顶</a>
							</el-dropdown-item>
							<el-dropdown-item class="dropdown-item-delete" icon="el-icon-delete" @click.native="handleDelete(item, '2')">
								<a>删除</a>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

			<!-- 更早对话 -->
			<div v-if="asideList.earlier && asideList.earlier.length > 0" class="group-section">
				<div class="group-title">更早</div>
				<div v-for="item in asideList.earlier" :key="item.id" :class="{ 'aside-item-active': activeId == item.id}" class="aside-item">
					<div class="chat-title" @click.stop="openChat(item)" :title="item.title">
						{{ item.title }}
					</div>
					<el-dropdown class="aside-item-edit" placement="bottom-start" trigger="click" >
						<span class="el-dropdown-link">
							<i class="el-icon-more"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item icon="el-icon-edit" @click.native="handleRename(item, 3)">
								<a>重命名</a>
							</el-dropdown-item>
							<el-dropdown-item icon="el-icon-top" @click.native="handleTop(item)">
								<a>置顶</a>
							</el-dropdown-item>
							<el-dropdown-item class="dropdown-item-delete" icon="el-icon-delete" @click.native="handleDelete(item, 3)">
								<a>删除</a>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

			<!-- <div v-for="(data, i) in asideList" :key="i">
				<div :ref="data.id" :class="{ 'aside-item-active': activeId == data.id }" class="aside-item">
					<div style="flex: 1" @click.stop="openChat(data)">
						<span v-if="data.status == 1" style="color: #409eff; margin-right: 5px">
							<i class="el-icon-top"></i>
						</span>
						{{ data.title }}
					</div>
					<el-dropdown class="aside-item-edit" placement="bottom-start" trigger="click">
						<span class="el-dropdown-link">
							<i class="el-icon-more"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item icon="el-icon-edit" @click.native="handleRename(data)">
								<a>重命名</a>
							</el-dropdown-item>
							<el-dropdown-item :icon="data.status == 1 ? 'el-icon-bottom' : 'el-icon-top'" @click.native="handleTop(data)">
								<a>{{ data.status == 1 ? '取消置顶' : '置顶' }}</a>
							</el-dropdown-item>
							<el-dropdown-item icon="el-icon-delete" @click.native="handleDelete(data)">
								<a>删除</a>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div> -->
		</div>

		<!--		<div class="shortcut-main">-->
		<!--			<div v-for="item in shortcutList" :key="item.id" class="shortcut-title" @click="openNewChat">-->
		<!--				<el-link :underline="false"> <i class="el-icon-circle-plus-outline" style="margin-right: 4px"></i>{{ item.title }}</el-link>-->
		<!--			</div>-->
		<!--		</div>-->
	</el-aside>
</template>

<script>
	import { renameConversation, deleteConversation, topConversation } from '@/api/ai/ai.js';
	import TMessage from '@/utils/TMessage';
	import TMessageBox from '@/utils/TMessageBox';
	import bus from '@/bus';
	import { mapGetters } from 'vuex';
	export default {
		props: {
			asideList: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				shortcutList: [
					{
						id: 'shortcut-1',
						title: '快捷方式1'
					},
					{
						id: 'shortcut-2',
						title: '快捷方式2'
					},
					{
						id: 'shortcut-3',
						title: '快捷方式3'
					}
				]
			};
		},
		created() {
			this.$nextTick(() => {
				const id = this.$route.query.id;
				const title = this.$route.query.title;
				if (id) {
					bus.$emit('openHistoryChat', { id, title });
				}
			});
		},

		mounted() {
			// 添加滚动事件监听
			this.$nextTick(() => {
				const scrollContainer = this.$el.querySelector('.aside-main');
				if (scrollContainer) {
					// console.log('Added scroll event listener');
					scrollContainer.addEventListener('scroll', this.handleScroll);
				}
			});
		},

		beforeDestroy() {
			// 移除滚动事件监听
			const scrollContainer = this.$el.querySelector('.aside-main');
			if (scrollContainer) {
				scrollContainer.removeEventListener('scroll', this.handleScroll);
			}
		},
		methods: {
			handleScroll(e) {
				const { scrollTop, scrollHeight, clientHeight } = e.target;
				// 当滚动距离底部小于 200px 时，触发加载更多
				if (scrollHeight - scrollTop - clientHeight < 200) {
					// console.log('Loading more...');
					this.$emit('loadMore');
				}
			},
			handleRename(data, group) {
				this.$prompt('请为对话重命名', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					closeOnClickModal: false,
					inputValue: data.title || '', // 回显之前的名称
					inputValidator: value => {
						if (!value || value.trim() === '') {
							return '标题不能为空';
						}
						return true;
					},
					inputErrorMessage: '标题不能为空'
				})
					.then(({ value }) => {
						renameConversation(data.id, value).then(res => {
							TMessage.success(res.msg);
							// 更新本地数据
							if (group == 1) {
								const index = this.asideList.pinned.findIndex(item => item.id === data.id);
								if (index !== -1) {
									this.asideList.pinned[index].title = value;
								}
							}
							if (group == 2) {
								const index = this.asideList.today.findIndex(item => item.id === data.id);
								if (index !== -1) {
									this.asideList.today[index].title = value;
								}
							}
							if (group == 3) {
								const index = this.asideList.earlier.findIndex(item => item.id === data.id);
								if (index !== -1) {
									this.asideList.earlier[index].title = value;
								}
							}
							// const index = this.asideList.findIndex(item => item.id === data.id);
							// if (index !== -1) {
							// 	this.asideList[index].title = value;
							// }
							if (this.$route.query.id == data.id) {
								bus.$emit('openHistoryChat', { id: data.id, title: data.title });
							}
						});
					})
					.catch(() => {});
			},

			handleDelete(data, group) {
				TMessageBox.confirm('是否继续删除话题?', '提示')
					.then(() => {
						deleteConversation(data.id).then(res => {
							if (group == 1) {
								const index = this.asideList.pinned.findIndex(item => item.id === data.id);
								if (index !== -1) {
									this.asideList.pinned.splice(index, 1);
								}
							}
							if (group == 2) {
								const index = this.asideList.today.findIndex(item => item.id === data.id);
								if (index !== -1) {
									this.asideList.today.splice(index, 1);
								}
							}
							if (group == 3) {
								const index = this.asideList.earlier.findIndex(item => item.id === data.id);
								if (index !== -1) {
									this.asideList.earlier.splice(index, 1);
								}
							}

							// 如果当前正在查看的对话就是被删除的对话
							if (this.$route.query.id === data.id) {
								bus.$emit('openNewChat');
							}
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						});
					})
					.catch(() => {
						// 用户点击取消
						// console.log('用户取消操作');
					});
			},

			//置顶
			handleTop(data) {
				let msg = '';
				if (data.status == 1) {
					msg = '是否取消置顶?';
				} else {
					msg = '是否置顶?';
				}
				let params = {
					conversation_id: data.id,
					status: data.status == 1 ? 0 : 1
				};
				topConversation(params).then(res => {
					TMessage.success(res.msg);
					// 刷新列表
					this.$emit('getAsideList');
				});
			},

			//开启新对话
			openNewChat() {
				// 检查是否登录
				if (!this.uisLogin) {
					// TMessage.warning('请先登录');
					this.$message.warning('请先登录，体验更多功能');
					return;
				}
				bus.$emit('openNewChat');
			},

			//打开历史对话
			openChat(data) {
				this.$emit('openChat');
				bus.$emit('openHistoryChat', { id: data.id, title: data.title });
			}
		},

		computed: {
			activeId() {
				return this.$route.query.id;
			},
			...mapGetters('User', ['uisLogin'])
		}
	};
</script>

<style lang="less" scoped>
	.aside-container {
		// Webkit 浏览器滚动条样式
	}

	.aside-container .aside-title-disabled {
		color: #bcbec2;
		background-color: #f4f4f5;
		border-color: #e9e9eb;
		cursor: not-allowed;
	}

	.el-dropdown-link {
		border-radius: 50%;
		padding: 4px 8px;
	}

	.el-dropdown-link:hover {
		background: #e5e8eb;
	}

	/deep/ .el-dropdown-menu__item {
		display: flex;
		align-items: center;
	}

	/deep/ .dropdown-item-delete {
		color: #f56c6c;

		i {
			color: #f56c6c;
		}

		&:hover {
			background-color: #fef0f0 !important;
			color: #f56c6c !important;
		}
	}

	.aside-container {
		padding: 10px;
		margin-bottom: 0px;
		display: flex;
		width: 260px !important;
		flex-direction: column;
		justify-content: space-between;
		background: #f9fafb;
		height: calc(100vh - 72px) !important;
	}

	.aside-main {
		margin-top: 70px;
		height: calc(100vh - 130px);
		overflow-y: auto;
		overflow-x: hidden;
		scrollbar-width: thin; // Firefox 滚动条样式

		&::-webkit-scrollbar {
			height: 6px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 3px;
		}

		&::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;

			&:hover {
				background: #a8a8a8;
			}
		}
	}

	.aside-title {
		background: #fff;
		text-align: center;
		margin: 20px 0px;
		line-height: 40px;
		position: fixed;
		width: 236px;
		height: 40px;
		z-index: 99;
		cursor: pointer;
		border: 1px solid rgba(103, 158, 254, 0);
		border-radius: 100px;
		color: #0f1115;
		transition: box-shadow 0.3s;
		font-size: 14px;
		box-shadow: 0 -2px 2px rgba(72, 104, 178, 0.04), 0 2px 2px rgba(106, 111, 117, 0.09), 0 1px 2px rgba(72, 104, 178, 0.08);
	}

	.aside-title:hover {
		box-shadow: 0 4px 4px rgba(72, 104, 178, 0.04), 0 -3px 4px rgba(72, 104, 178, 0.04), 0 6px 6px rgba(106, 111, 117, 0.1);
	}

	.aside-item {
		display: flex;
		cursor: pointer;
		border-radius: 12px;
		// padding: 9px 6px 9px 10px;
		font-size: 14px;
		color: #0f1115;

		.chat-title {
			flex: 1;
			padding: 9px 6px 9px 10px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.aside-item:hover,
	.aside-item:focus-within {
		background-color: #f1f3f5;
		cursor: pointer;
		// border-radius: 8px;

		.aside-item-edit {
			display: block;
			margin-top: 9px;
			margin-right: 6px;
		}

		.el-dropdown-link {
			background: #e5e8eb;
		}
	}

	.aside-item-edit {
		display: none;
	}

	.aside-item-active {
		background: #dbeafe !important;
		color: #155dfc !important;
	}

	.shortcut-title {
		line-height: 40px;
		width: 236px;
		height: 40px;
		cursor: pointer;
		color: #0f1115;
		transition: box-shadow 0.3s;
		font-size: 14px;
	}

	.group-title {
		z-index: 20;
		color: #81858c;
		background-color: #f9fafb;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		margin-bottom: 2px;
		margin-left: -2px;
		margin-right: -2px;
		padding: 6px 12px 0;
		font-size: 12px;
		font-weight: 500;
		line-height: 18px;
		position: -webkit-sticky;
		position: sticky;
		top: 0;
	}

	.group-section {
		// margin-top: 16px;
		position: relative;
	}
</style>
